import {api} from "@/api/client";
import {Tenant} from "@/api/types/Tenant";

type ListParams = {
  limit?: number,
  skip?: number,
  search?: string,
};

export type TenantData = {
    limit: number,
    skip: number,
    total: number,
    data: Tenant[]
}

export const buildTenantsApi = (client = api) => ({
  async list(limit?: number, skip?: number, search?: string) {
    const params: ListParams = {limit: limit, skip: skip, search: search}
    const result = await client.get<Tenant[]>('api/tenants', {params})
    return result.data;
  },

  async listAll(limit?: number, skip?: number, search?: string) {
    const params: ListParams = {limit: limit, skip: skip, search: search}
    const result = await client.get<TenantData>('api/tenants/list', {params})
    return result.data;
  }

});

export const {
  list,
  listAll,
} = buildTenantsApi();